jQuery(document).ready(function ($) {
	let timeout = null;

	// search field effects
	$('.wawSearchFiltered__inputWrapper').focusin(function () {
		$(this).addClass('focused');
	});

	// Loop through each search input field
	$('input[type="search"]').each(function () {
		// Find the closest results container for this input field
		const form = $(this).closest('form');
		const resultsContainer = $(form).find('.searchResults');
		const inputWrapper = $(form).find('.wawSearchFiltered__inputWrapper');
		const inputWrapperInput = $(form).find('.wawSearchFiltered__inputWrapper input');
		const inputWrapperButton = $(form).find('.wawSearchFiltered__inputWrapper button');

		$(inputWrapperButton).click(function (e) {
			e.preventDefault();
			$(inputWrapperInput).val('');
			$(inputWrapper).removeClass('focused');
			$(resultsContainer).removeClass('is-showing');
		});

		const html = '';

		// Attach input event handler to this input field
		$(this).on('input', function (event) {
			// Log the current value of the input field
			// Pass reference to displayResults function
			// displayResults($(this).val(), resultsContainer);

			clearTimeout(timeout);
			timeout = setTimeout(() => {
				const query = $(event.target).val();

				if (query.length > 2) {
					// Start searching after 3 characters
					fetchSearchResults(query, resultsContainer);
				} else {
					resultsContainer.html(''); // Clear results if less than 3
					$(resultsContainer).removeClass('is-showing');
				}
			}, 500);
		});
	});

	function highlightText(text, query) {
		if (!query) return text;

		// Split the query into individual words
		const words = query.split(' ').filter((word) => word.length > 0);

		// Create a regular expression to match any of the words
		const regex = new RegExp(`(${words.join('|')})`, 'gi');

		// Replace matched words with highlighted HTML
		return text.replace(regex, '<span class="highlight">$1</span>');
	}

	const nonce = wawQueryApp.nonce;

	// todo: nonce
	function fetchSearchResults(query, resultsContainer) {
		$.ajax({
			// headers: {
			// 	'X-WP-Nonce': nonce, // Include nonce in the request headers
			// },
			url: `/wp-json/waw-blocks/v1/live-search/?query=${encodeURIComponent(query)}`,
			method: 'GET',
			dataType: 'json',
			success: function (data) {
				displayResults(query, data, resultsContainer);
			},
			error: function (error) {
				console.error('Error:', error);
			},
		});
	}

	function displayResults(query, results, resultsContainer) {
		resultsContainer.addClass('is-showing');
		if (results.length === 0) {
			resultsContainer.html('<p>No results found</p>');
			return;
		}

		// Process the results to highlight matching text
		const highlightedResults = results.map((result) => {
			const title = highlightText(result.title, query);
			return { ...result, title };
		});

		// Display the results
		resultsContainer.html(
			highlightedResults
				.map(
					(result) => `
            <div class="search-result">
                <a href="${result.url}">
                    ${result.title}
                </a>
            </div>
        `
				)
				.join('')
		);
	}
});
